import type { ReactNode } from "react"

import type { MembershipRole } from "@productlane/db/browser"

import { useRole } from "@/lib/useRole"

interface Props {
	children: ReactNode
	not?: Array<MembershipRole>
	only?: Array<MembershipRole>
}

export function RoleCheck({ children, not, only }: Props) {
	const { role } = useRole()

	if (!role) {
		return null
	}

	if (not && not.includes(role)) {
		return null
	}

	if (only && !only.includes(role)) {
		return null
	}

	return <>{children}</>
}
